var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEthereum = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4013_246499)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4013_246499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4013_246499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -1,
    y: -1,
    width: 23,
    height: 23
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7602 21.7602H-0.760201V-0.760193H21.7602V21.7602Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4013_246499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7858 10.5C20.7858 16.1826 16.1826 20.7858 10.5 20.7858C4.8174 20.7858 0.214199 16.1826 0.214199 10.5C0.214199 4.8174 4.8174 0.214203 10.5 0.214203C16.1826 0.214203 20.7858 4.8174 20.7858 10.5Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4013_246499)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4013_246499",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.7942 0.205811H0.209999V20.79H20.7942V0.205811Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4013_246499)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    transform: "matrix(1 0 0 -1 -1.52588e-05 21)",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 4.20978V8.6457L14.3741 10.3211L10.6248 4.20978Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 4.20978L6.875 10.3211L10.6248 8.6457V4.20978Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 13.1956V16.2098L14.3766 11.0192L10.6248 13.1956Z",
    fill: "white",
    fillOpacity: 0.602
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 16.2098V13.1951L6.875 11.0192L10.6248 16.2098Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6248 12.498L14.3741 10.321L10.6248 8.6467V12.498Z",
    fill: "white",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.875 10.321L10.6248 12.498V8.6467L6.875 10.321Z",
    fill: "white",
    fillOpacity: 0.602
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4013_246499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEthereum);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ethereum.8fed8be6298e71abbc038eb5a57802c1.svg";